//AUTH
export const RESET_PASSWORD = "/reset-password"
export const UPDATE_PASSWORD = "/update-user-password"
export const RESET_AGENCY_PASSWORD = "/reset-agency-user-password"
export const FORGOT_PASSWORD = "/forgot-Password"

//DASHBOARD
export const GET_DASHBOARD_DATA = "/dashboard"

// AGENT
export const CREATE_NEW_AGENT = "/agent/create"
export const GET_VOICES = "/agent/voices"
export const VOICE_PREVIEW = "/agent/voice-preview"
export const GET_ALL_AGENTS = "/agent/all"
export const GET_SINGLE_AGENT = "/agent/get"
export const UPDATE_AGENT = "/agent/update"
export const UPDATE_AGENT_STATUS = "/agent/status"
export const MAKE_PRIMARY = "/agent/make-primary"

// PROMPT
export const GET_PROMPT = "/prompt"
export const CREATE_PROMPT = "/prompt"
export const UPDATE_PROMPT = "/prompt"
export const DELETE_PROMPT = "/prompt"
export const GET_PROMPT_TEMPLATE = "/prompt-template"
export const QUICK_START = "/prompt/quick-start"
export const POST_COMPANY_INFO = "/prompt/company-info"
export const CHECK_PROMPT = "/prompt/check"
export const TIDY_PROMPT = "/prompt/tidy"
export const GET_GUARDRAILS = "/prompt/guardrails"
export const AI_WRITE_PROMPT = "/prompt/ai-write"
export const PROMPT_VERSIONS = "/prompt"
export const AI_EDIT_PROMPT = "/prompt"

// MAKE CALL
export const MAKE_CALL = "/call/make-call"
export const SEND_CALL_OTP = "/call/send-call-otp"
export const DEMO_CALL = "/call/demo-call"
export const CALL_LOGS = "/call/logs"
export const TEST_CALL_LOGS = "/call/test-call-logs"
export const CALL_RECORDINGS = "/call/recording"
export const END_CALL = "/call/hangup"

// CAMPAIGNS
export const CREATE_NEW_CAMPAIGN = "/campaign"
export const CREATE_CAMPAIGN_FILES = "/campaign/files"
export const GET_CAMPAIGNS = "/campaign"
export const GET_SINGLE_CAMPAIGN = "/campaign/list"
export const ADD_NEW_CAMPAIGN_DATA = "/campaign/new-data"
export const UPDATE_CAMPAIGN_INFO = "/campaign"
export const CAMPAIGN_STATUS = "/campaign/status"

// Web Hook GHL
export const GET_TAGS = "/webhook"

// Configuration
export const GET_CONFIGURATION = "/integration"
export const POST_CONFIGURATION = "/integration"
export const GET_EMAIL_CONFIGURATION = "/configuration"
export const PUT_EMAIL_CONFIGURATION = "/configuration"
export const POST_WEBHOOK_CONFIGURATION = "/configuration/webhook"
export const GET_WEBHOOK_CONFIGURATION = "/configuration/webhook/user"
export const DELETE_WEBHOOK_CONFIGURATION = "/configuration"

// Payments and Billing
export const GET_PLANS = "/payment/plans"
export const GET_PHONE_NUMBERS = "/call/numbers"
export const PAYMENT_PROCESS = "/payment/subscribe"
export const GET_BILLING_DETAILS = "/payment/billing-details"
export const CANCEL_SUBSCRIPTION = "/payment/cancel"
export const GET_INVOICES = "/payment/invoices"
export const ADD_FUNDS = "/payment/add-funds"
export const AUTO_TOPUP = "/payment/auto-topup"
export const GET_PAYMENT_METHODS = "/payment/default-card"
export const ADD_CARD = "/payment/add-card"
export const SET_PRIMARY_CARD = "/payment/default-card"
export const REMOVE_CARD = "/payment/remove-card"
export const CHOOSE_ANOTHER_CONTRY = "/call/request-phone-number"
export const TRIAL_DETAILS = "/payment/trial-details"
export const LETSTALK = "/payment/lets-talk"

// USER
export const GET_USER_PROFILE = "/user/profile"
export const UPDATE_TOUR = "/user/getting-started"